import type { Filter } from './analytics'
import type { ResultSetData } from './query'
import type { NormalizedFieldEntry, SourceValueDimension } from './sourceValue'
import type { MEASURE_TITLES, DIMENSION_TITLES } from '~/constants/analytics'

export enum DataHealthCheck {
  HIGH_SALARY_RAISE = 'HIGH_SALARY_RAISE',
  HIGH_TIME_TO_HIRE = 'HIGH_TIME_TO_HIRE',
  TOO_OLD_ARRIVAL_DATE = 'TOO_OLD_ARRIVAL_DATE',
  NULL_BASE_SALARY = 'NULL_BASE_SALARY',
  NULL_EMPLOYEE_ARRIVAL_DATE = 'NULL_EMPLOYEE_ARRIVAL_DATE',
  NULL_EMPLOYEE_GENDER = 'NULL_EMPLOYEE_GENDER',
  NULL_EMPLOYEE_SENIORITY = 'NULL_EMPLOYEE_SENIORITY',
  NULL_EMPLOYEE_BIRTH_DATE = 'NULL_EMPLOYEE_BIRTH_DATE',
  NULL_EMPLOYEE_NATIONALITY = 'NULL_EMPLOYEE_NATIONALITY',
  NULL_EMPLOYEE_CAREER_LEVEL = 'NULL_EMPLOYEE_CAREER_LEVEL',
  NULL_EMPLOYEE_EMPLOYMENT_TYPE = 'NULL_EMPLOYEE_EMPLOYMENT_TYPE',
  NULL_EMPLOYEE_JOB_TITLE = 'NULL_EMPLOYEE_JOB_TITLE',
  NULL_EMPLOYEE_DEPARTMENT = 'NULL_EMPLOYEE_DEPARTMENT',
  NULL_EMPLOYEE_GROUP_1 = 'NULL_EMPLOYEE_GROUP_1',
  NULL_EMPLOYEE_LOCATION_OFFICE = 'NULL_EMPLOYEE_LOCATION_OFFICE'
}

export enum DataHealthCheckType {
  NULL_VALUES = 'NULL_VALUES',
  INCOHERENT_VALUES = 'INCOHERENT_VALUES'
}

export enum NormalizationCheckStatus {
  LOADING = 'LOADING',
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

export enum DataHealthCheckStatus {
  LOADING = 'LOADING',
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  INAPPLICABLE_FILTERS = 'INAPPLICABLE_FILTERS'
}

export interface DataHealthCheckWithStatus {
  check: DataHealthCheck
  type: DataHealthCheckType
  status: DataHealthCheckStatus
  dimensionShortTitle: string
}

export type DataQualityDetail = {
  normalizationChecks: {
    [key in NormalizedFieldEntry]?: NormalizationCheckStatus | undefined
  }
  dataHealthChecks: {
    [key in DataHealthCheck]?: DataHealthCheckStatus | undefined
  }
  sourceValueDimensions: SourceValueDimension[]
}

export type ExplorerListView = {
  measure: MEASURE_TITLES
  columns: (MEASURE_TITLES | DIMENSION_TITLES)[]
  filters: Filter[]
}

export type GetDataHealthChecksDto = {
  check: DataHealthCheck
  type: DataHealthCheckType
  dimension: DIMENSION_TITLES
}

export type DataHealthChecks = {
  [key in DataHealthCheck]?: {
    type: DataHealthCheckType
    dimension: DIMENSION_TITLES
  }
}

export type DataHealthCheckDetailDto = ResultSetData & {
  query: {
    dimensions: DIMENSION_TITLES[]
    measures: MEASURE_TITLES[]
  }
  explorerListView: ExplorerListView
  status: DataHealthCheckStatus
}
